<form class="flex flex-col items-center px-3" (ngSubmit)="onSubmit()">
  <ng-otp-input
    [formControl]="verificationCode"
    [config]="otpConfig()"
    onblur="true"></ng-otp-input>

  @if (verificationCode.hasError('required') && !verificationCode.pristine) {
    <mat-error>Code is required</mat-error>
  }

  @if (verificationCode.hasError('minlength') || verificationCode.hasError('maxlength')) {
    <mat-error> Code must be 6 digits </mat-error>
  }

  <!-- Since there is no way to resend the code when MFA has already been set up, the user is notified  -->
  @if (
    showResendHint() &&
    !mustVerify() &&
    selectedMethod() !== softwareTokenMFA &&
    !isSessionExpired() &&
    !tooManyAttempts() &&
    !limitExceededException()
  ) {
    <span class="my-4 text-accent-700 font-bold">
      If you have not received your verification code, please
      <span
        class="text-blue-500 underline hover:text-blue-700 cursor-pointer"
        (click)="closeDialog()"
        (keydown.enter)="closeDialog()"
        tabindex="0"
        role="button">
        Log In
      </span>
      again to request a new code.
    </span>
  }

  @if (isCorporateUser()) {
    <span class="mt-2">
      If you are unable to receive your MFA (Multi-Factor Authentication) verification code or need to update your
      preferred MFA method, please contact the Help Desk for assistance.
    </span>
  } @else {
    <span class="mt-2">
      If you are still unable to receive your MFA (Multi-Factor Authentication) verification code, need to update your
      email address or phone number, or would like to change how you receive verification codes, please contact
      <a [routerLink]="'contact'" class="text-blue-500 underline hover:text-blue-700" target="_blank">
        Customer Support
      </a>
      for assistance.
    </span>
  }

  <!-- Session Expired -->
  @if (isSessionExpired()) {
    <div class="error">
      <mat-icon>error</mat-icon>
      <span>
        Session is expired, please
        <span
          class="text-blue-500 underline hover:text-blue-700 cursor-pointer"
          (click)="closeDialog()"
          (keydown.enter)="closeDialog()"
          tabindex="0"
          role="button">
          Log In
        </span>
        again.
      </span>
    </div>
  }
  <!-- Attempts Error -->
  @if (tooManyAttempts()) {
    <div class="error">
      <mat-icon>error</mat-icon>
      <span>
        Too many invalid credential attempts. User temporarily locked. Please try
        <span
          class="text-blue-500 underline hover:text-blue-700 cursor-pointer"
          (click)="closeDialog()"
          (keydown.enter)="closeDialog()"
          tabindex="0"
          role="button">
          Log In
        </span>
        again after a few seconds.
      </span>
    </div>
  }
  <!-- Code Attempts Error -->
  @if (limitExceededException()) {
    <div class="error">
      <mat-icon>error</mat-icon>
      <span>
        Attempt limit exceeded. Please try
        <span
          class="text-blue-500 underline hover:text-blue-700 cursor-pointer"
          (click)="closeDialog()"
          (keydown.enter)="closeDialog()"
          tabindex="0"
          role="button">
          Log In
        </span>
        again later.
      </span>
    </div>
  }
  <!-- General Cognito Errors -->
  @if (errorMessage) {
    <div class="error">
      <mat-icon>error</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>
  }

  @if (isLoading) {
    <div class="loading">
      <mat-progress-spinner mode="indeterminate" diameter="28"></mat-progress-spinner>
      <span>Verifying...</span>
    </div>
  }
  <div class="flex flex-row gap-5">
    @if (selectedMethod() !== softwareTokenMFA && mustVerify()) {
      <button
        mat-stroked-button
        color="primary"
        [disabled]="isLoading || isSessionExpired() || tooManyAttempts() || limitExceededException()"
        class="mt-4"
        type="button"
        (click)="generateCode()">
        Resend Code
      </button>
    }

    <button
      mat-flat-button
      color="primary"
      class="mt-4"
      type="button"
      (click)="onSubmit()"
      [disabled]="
        isLoading ||
        verificationCode.invalid ||
        verificationCode.value.length !== 6 ||
        isSessionExpired() ||
        tooManyAttempts() ||
        limitExceededException()
      ">
      Verify
    </button>
  </div>
</form>
